import axios from "../plugins/axios";

export default class TranslationApi {
    getTranslations(lang = 'id') {
        return axios.get("/translations", {
            params: { lang }
        });
    }
}
